<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 20px 20px 20px 280px;

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }

  .elmargin {
    margin-bottom: 21px;
  }
}
</style>
<template>
  <div
      class="box"
  >
    <p class="page_title">功能管理</p>

    <div class="query_box">
      <el-form :model="form" ref="form" label-position="100px" size="medium">
        <el-row :gutter="10" class="elmargin">
          <el-col :span="5">
            <el-input
                v-model="form.name"
                size="medium"
                placeholder="功能名称查询"
            ></el-input>
          </el-col>

          <el-col :span="5">
            <el-button
                size="medium"
                type="primary"
                icon="el-icon-search"
                @click="qryClick()"
            >查询
            </el-button
            >
            <el-button size="medium" icon="el-icon-refresh">重置</el-button>
          </el-col>
          <el-col :span="8" style="text-align: right">
            <el-button
                size="medium"
                type="primary"
                icon="el-icon-plus"
                @click="addVisible = true"
            >添加功能
            </el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table_box">
      <data-table :columns="tableColumns" :data="tableData1" @selects="selects">
        <el-table-column fixed="right" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button
                @click="handleClick(scope.$index, scope.row)"
                type="primary"
                icon="el-icon-edit"
            >编辑
            </el-button
            >
            <el-button
                type="danger"
                icon="el-icon-delete"
                @click="del(scope.$index, scope.row)"
            >删除
            </el-button
            >
            <el-button
                type="primary"
                @click="queryFunUser(scope.$index, scope.row)"
            >所属用户
            </el-button
            >
            <el-button
                type="primary"
                @click="queryFunRole(scope.$index, scope.row)"
            >所属角色
            </el-button
            >
          </template>
        </el-table-column>
      </data-table>
      <Pagination :page.sync="page" @pageChange="qryClick"/>
      <the-add
          :visible.sync="addVisible"
          @success="operationaddSuccess"
      ></the-add>
      <edit
          :editForm="selectedData"
          :visible.sync="editVisible"
          @success="operationSuccess"
      ></edit>
      <user-list
          :memberForm="userListData"
          :visible.sync="userListVisible"
          @success="userListSuccess"
      ></user-list>
      <role-list
          :memberForm="roleListData"
          :visible.sync="roleListVisible"
          @success="roleListSuccess"
      ></role-list>
    </div>
  </div>
</template>

<script>
import index from "@/components/mixins/index";
import optionVal from "@/components/mixins/optionVal";
import DataTable from "@/components/common/DataTable.vue";
import {getFunctionInfo, delFunctionInfo} from "./api/index";
import TheAdd from "./TheAdd.vue";
import Edit from "./Edit.vue";
import UserList from "./UserList";
import RoleList from "./RoleList";

export default {
  mixins: [index, optionVal],
  data() {
    return {
      form: {
        name: "",
      },
      selectedData: {},
      userListData: {},
      roleListData: {},
      addVisible: false,
      editVisible: false,
      userListVisible: false,
      roleListVisible: false,
      tableData1: [],
      tableColumns: [
        {label: "功能名称", prop: "chName", minWidth: "60", sort: true},
        {label: "url", prop: "url", minWidth: "60"},
        {label: "类型", prop: "typeVal", minWidth: "60"},
        {label: "状态", prop: "enabledVal", minWidth: "60"},
        {label: "备注", prop: "remark", minWidth: "60"},
      ],
    };
  },
  components: {
    DataTable,
    TheAdd,
    Edit,
    UserList,
    RoleList,
  },
  mounted() {
    this.qryClick();
  },
  methods: {
    handleClick(index, row) {
      this.selectedData = Object.assign({}, row);
      this.editVisible = true;
    },
    qryClick() {
      let data = {};
      data.chName = this.form.name;
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      getFunctionInfo(data)
          .then((res) => {
            this.tableData1 = res.data.data.records;
            this.tableData1.map((obj) => {
              obj.enabledVal = this.enabledOptions.get(obj.enabled);
              obj.typeVal = this.typeOptions.get(obj.type);
            });
            this.page.total = res.data.data.total;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            });
          });
    },
    operationSuccess() {
      this.editVisible = false;
      this.qryClick();
    },
    userListSuccess() {
      this.userListVisible = false;
    },
    roleListSuccess() {
      this.roleListVisible = false;
    },
    operationaddSuccess() {
      this.addVisible = false;
      this.qryClick();
    },
    del(index, row) {
      this.$confirm(
          "此操作将永久删除该用户组以及该组下关联的用户以及角色, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            let id = row.id;
            delFunctionInfo(id)
                .then((res) => {
                  this.$message({
                    type: "info",
                    message: "删除成功",
                  });
                  this.qryClick();
                })
                .catch((err) => {
                  this.loading = false;
                  this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
                    type: "error",
                  });
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    queryFunUser(index, row) {
      this.userListVisible = true;
      this.userListData = row;
    },
    queryFunRole(index, row) {
      this.roleListVisible = true;
      this.roleListData = row;
    },
  },
};
</script>

